import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaBolt, FaRupeeSign, FaSolarPanel, FaHome } from 'react-icons/fa';

const Calculator = () => {
  const [billAmount, setBillAmount] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Backend Rates State (Defaults agar API fail ho)
  const [rates, setRates] = useState({
    unitPrice: 7.50,      // Default Electricity Rate
    costPerKW: 50000,     // Default Installation Cost
    subsidyAmount: 78000  // Default Max Subsidy
  });

  // API URL


  // 1. Fetch Rates from Backend on Load
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await api.get('/Calculator');
        if (response.data) {
          setRates({
            unitPrice: response.data.unitPrice,
            costPerKW: response.data.costPerKW,
            subsidyAmount: response.data.subsidyAmount
          });
        }
      } catch (error) {
        console.error("Error fetching calculator rates:", error);
        // Error aane par defaults use honge jo state me set hain
      }
    };

    fetchRates();
  }, []);
const calculateSavings = () => {
    const bill = parseFloat(billAmount);
    
    // Validation
    if (!bill || bill <= 0) {
      alert('Please enter a valid monthly bill amount');
      return;
    }

    setLoading(true);
    
    setTimeout(() => {
      // --- 1. Monthly Units Consumption ---
      // Maan lijiye rate ₹7.50 hai (Admin se aa raha hai)
      const monthlyUnits = bill / rates.unitPrice; 

      // --- 2. System Size Calculation ---
      // 1kW Solar makes approx 120 units per month
      let exactKwNeeded = monthlyUnits / 120;

      // Minimum 1kW rakhna padega, usse chhota system practical nahi hai
      // Aur hum 0.5 ke multiple me round karenge (e.g. 1.2KW -> 1.5KW)
      let systemSize = Math.ceil(exactKwNeeded * 2) / 2;
      
      if (systemSize < 1) {
        systemSize = 1; // Minimum system size
      }

      // --- 3. Annual Savings ---
      // Savings = System Size * 120 units * 12 months * Rate
      // (Agar bill chhota hai to savings bill se zyada dikh sakti hai - Net Metering benefit)
      const unitsGeneratedPerMonth = systemSize * 120;
      const annualSavings = unitsGeneratedPerMonth * 12 * rates.unitPrice;

      // --- 4. Subsidy Calculation (PM Suryaghar Rules) ---
      let calculatedSubsidy = 0;
      if (systemSize <= 1) calculatedSubsidy = 30000;
      else if (systemSize === 2) calculatedSubsidy = 60000;
      else if (systemSize >= 3) calculatedSubsidy = 78000;
      else {
        // For values like 1.5kW, 2.5kW (Pro-rata calculation roughly)
        if(systemSize < 2) calculatedSubsidy = 30000 + (systemSize - 1) * 30000;
        else calculatedSubsidy = 60000 + (systemSize - 2) * 18000;
      }
      
      // Cap subsidy at 78000 (Max limit)
      if(calculatedSubsidy > rates.subsidyAmount) calculatedSubsidy = rates.subsidyAmount;


      // --- 5. Other Metrics ---
      const energyGenerated = systemSize * 1440; // 120 units * 12 months
      const roofSpace = systemSize * 100; // Approx 100 sqft per kW
      
      // ROI (Payback) Calculation
      const totalCost = systemSize * rates.costPerKW;
      const netCost = totalCost - calculatedSubsidy;
      const paybackPeriod = netCost > 0 ? (netCost / annualSavings).toFixed(1) : 0;

      setResults({
        systemSize, // Ab ye sahi kW dikhayega (e.g., 1kW, 1.5kW)
        annualSavings: Math.round(annualSavings),
        energyGenerated: Math.round(energyGenerated),
        roofSpace: Math.round(roofSpace),
        subsidy: Math.round(calculatedSubsidy),
        paybackPeriod
      });
      
      setLoading(false);
    }, 800);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      calculateSavings();
    }
  };

  return (
    <section className="calculator-section py-5 bg-light" id="calculator">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="badge bg-success mb-3 px-3 py-2">
            <i className="bi bi-calculator-fill me-2"></i>
            Solar Savings Calculator
          </span>
          <h2 className="display-5 fw-bold text-dark mb-3">
            Calculate Your Solar Savings
          </h2>
          <p className="lead text-muted">
            Find out how much you can save with solar energy in just 30 seconds
          </p>
        </div>

        {/* Calculator Card */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg calculator-card">
              <div className="card-body p-5">
                <div className="row">
                  {/* Left Side - Input */}
                  <div className="col-lg-5 mb-4 mb-lg-0">
                    <div className="calculator-input-section">
                      <div className="text-center mb-4">
                        <div 
                          className="calculator-icon-wrapper mx-auto"
                          style={{
                            width: '100px',
                            height: '100px',
                            background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 10px 30px rgba(0, 208, 132, 0.3)'
                          }}
                        >
                          <FaBolt style={{ fontSize: '3rem', color: '#ffffff' }} />
                        </div>
                      </div>

                      <label className="form-label fw-bold mb-3" style={{ fontSize: '1.1rem', color: '#1B3F6E' }}>
                        <FaRupeeSign className="me-2" style={{ color: '#00D084' }} />
                        Enter Your Monthly Electricity Bill
                      </label>
                      
                      <div className="input-group input-group-lg mb-4">
                        <span className="input-group-text bg-white" style={{ borderColor: '#00D084' }}>
                          <FaRupeeSign style={{ color: '#00D084' }} />
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          value={billAmount}
                          onChange={(e) => setBillAmount(e.target.value)}
                          onKeyPress={handleKeyPress}
                          placeholder="e.g., 3000"
                          style={{ 
                            borderColor: '#00D084',
                            fontSize: '1.5rem',
                            fontWeight: '600',
                            color: '#1B3F6E'
                          }}
                        />
                      </div>

                      <button 
                        onClick={calculateSavings} 
                        className="btn btn-lg w-100 text-white fw-bold rounded-pill shadow-lg"
                        disabled={loading}
                        style={{
                          background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)',
                          border: 'none',
                          padding: '1rem'
                        }}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Calculating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-calculator me-2"></i>
                            Calculate My Savings
                          </>
                        )}
                      </button>

                      <p className="text-muted text-center mt-3 small mb-0">
                        <i className="bi bi-info-circle me-1"></i>
                        Based on current rate: ₹{rates.unitPrice}/unit
                      </p>
                    </div>
                  </div>

                  {/* Right Side - Results */}
                  <div className="col-lg-7">
                    {!results ? (
                      <div className="calculator-placeholder text-center d-flex flex-column align-items-center justify-content-center h-100">
                        <div 
                          className="mb-4"
                          style={{
                            width: '150px',
                            height: '150px',
                            background: 'linear-gradient(135deg, #E8F8F3 0%, #E3F2FD 100%)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <FaSolarPanel style={{ fontSize: '4rem', color: '#00D084' }} />
                        </div>
                        <h4 className="fw-bold mb-3" style={{ color: '#1B3F6E' }}>
                          See Your Solar Potential
                        </h4>
                        <p className="text-muted mb-0">
                          Enter your monthly electricity bill to see how much you can save with solar
                        </p>
                      </div>
                    ) : (
                      <div className="results-grid">
                        <h5 className="fw-bold mb-4 text-center" style={{ color: '#1B3F6E' }}>
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          Your Solar System Recommendation
                        </h5>

                        {/* Results Cards */}
                        <div className="row g-3 mb-4">
                          {/* System Size */}
                          <div className="col-md-6">
                            <div className="result-card p-3 bg-white border-0 rounded shadow-sm">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="result-icon me-3"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <FaSolarPanel style={{ color: '#ffffff', fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted small mb-1">Recommended System</p>
                                  <h3 className="fw-bold mb-0" style={{ color: '#1B3F6E' }}>
                                    {results.systemSize} kW
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Annual Savings */}
                          <div className="col-md-6">
                            <div className="result-card p-3 bg-white border-0 rounded shadow-sm">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="result-icon me-3"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <FaRupeeSign style={{ color: '#ffffff', fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted small mb-1">Annual Savings</p>
                                  <h3 className="fw-bold mb-0" style={{ color: '#4CAF50' }}>
                                    ₹{results.annualSavings.toLocaleString()}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Energy Generated */}
                          <div className="col-md-6">
                            <div className="result-card p-3 bg-white border-0 rounded shadow-sm">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="result-icon me-3"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <FaBolt style={{ color: '#ffffff', fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted small mb-1">Energy Generated</p>
                                  <h3 className="fw-bold mb-0" style={{ color: '#FF9800' }}>
                                    {results.energyGenerated.toLocaleString()} Units
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Roof Space */}
                          <div className="col-md-6">
                            <div className="result-card p-3 bg-white border-0 rounded shadow-sm">
                              <div className="d-flex align-items-center">
                                <div 
                                  className="result-icon me-3"
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <FaHome style={{ color: '#ffffff', fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                  <p className="text-muted small mb-1">Roof Space Required</p>
                                  <h3 className="fw-bold mb-0" style={{ color: '#2196F3' }}>
                                    {results.roofSpace} Sqft
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Subsidy Highlight */}
                        <div className="alert alert-success border-0 shadow-sm mb-3" role="alert">
                          <div className="d-flex align-items-center">
                            <i className="bi bi-gift-fill fs-3 me-3"></i>
                            <div>
                              <h6 className="fw-bold mb-1">PM Suryaghar Subsidy</h6>
                              <p className="mb-0">
                                You are eligible for <strong className="fs-5">₹{results.subsidy.toLocaleString()}</strong> government subsidy!
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Payback Period */}
                        <div className="alert alert-info border-0 shadow-sm mb-3" role="alert">
                          <div className="d-flex align-items-center">
                            <i className="bi bi-clock-history fs-3 me-3"></i>
                            <div>
                              <h6 className="fw-bold mb-1">Payback Period</h6>
                              <p className="mb-0">
                                Your investment will pay back in approximately <strong>{results.paybackPeriod} years</strong>
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* CTA */}
                        <div className="text-center mt-4">
                          <a 
                            href="#contact" 
                            className="btn btn-outline-success btn-lg rounded-pill px-5"
                          >
                            <i className="bi bi-telephone-fill me-2"></i>
                            Get Free Site Survey
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards Below */}
        <div className="row mt-5 g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body text-center p-4">
                <i className="bi bi-shield-check text-success" style={{ fontSize: '3rem' }}></i>
                <h5 className="fw-bold mt-3 mb-2">25 Years Warranty</h5>
                <p className="text-muted small mb-0">Industry-leading warranty on panels and inverters</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body text-center p-4">
                <i className="bi bi-lightning-charge-fill text-warning" style={{ fontSize: '3rem' }}></i>
                <h5 className="fw-bold mt-3 mb-2">90% Bill Reduction</h5>
                <p className="text-muted small mb-0">Save up to 90% on your electricity bills</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body text-center p-4">
                <i className="bi bi-geo-alt-fill text-primary" style={{ fontSize: '3rem' }}></i>
                <h5 className="fw-bold mt-3 mb-2">Expert Installation</h5>
                <p className="text-muted small mb-0">NIT & DTU engineers handle your project</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .calculator-card {
          transition: all 0.3s ease;
          overflow: hidden;
        }
        
        .result-card {
          transition: all 0.3s ease;
        }
        
        .result-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1) !important;
        }
        
        .calculator-icon-wrapper {
          animation: pulse-icon 2s infinite;
        }
        
        @keyframes pulse-icon {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
        
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          opacity: 1;
        }
      `}</style>
    </section>
  );
};

export default Calculator;